import { apiClient } from './client'

interface ApiEnvelope<T> {
  code: number
  message: string
  data: T
}

export interface WebsiteSettings {
  iosAppUrl: string
  androidAppUrl: string
  iosDownloadQrUrl: string
  androidDownloadQrUrl: string
  miniProgramQrUrl: string
  copyrightOwner: string
  icpRecordNumber: string
  icpRecordUrl: string
  publicSecurityRecordNumber: string
  publicSecurityRecordUrl: string
  publicSecurityIconUrl: string
  logoUrl: string
  inverseLogoUrl: string
  heroImageUrl: string
  storyOneImageUrl: string
  storyTwoImageUrl: string
  storyThreeImageUrl: string
  subjectPhysicsImageUrl: string
  subjectChemistryImageUrl: string
  subjectBiologyImageUrl: string
  subjectScienceImageUrl: string
  sceneStudentImageUrl: string
  sceneClassroomImageUrl: string
}

export type LegalDocumentType =
  | 'USER_AGREEMENT'
  | 'PRIVACY_POLICY'
  | 'CHILD_PRIVACY_POLICY'
  | 'PERSONAL_INFO_COLLECTION_LIST'
  | 'THIRD_PARTY_INFORMATION_SHARING_LIST'
  | 'SYSTEM_PERMISSION_USAGE'

export interface LegalDocument {
  id: number
  agreementType: LegalDocumentType
  slug: string
  displayName: string
  version: string
  title: string
  summary?: string
  content: string
  plainText: string
  contentFormat: 'HTML'
  status: 'PUBLISHED'
  sortOrder: number
  publishedAt: string
  updatedAt: string
}

export async function getWebsiteSettings(): Promise<WebsiteSettings> {
  const response = await apiClient.get<ApiEnvelope<WebsiteSettings>>('/v1/platform/website-config')
  if (response.data.code !== 0) throw new Error(response.data.message)
  return response.data.data
}

export interface PublicPlatformSettings {
  customerServiceQrUrl: string
  customerServiceDescription: string
  encyclopediaEnabled: boolean
}

export async function getPublicPlatformSettings(): Promise<PublicPlatformSettings> {
  const response = await apiClient.get<ApiEnvelope<PublicPlatformSettings>>('/v1/platform/config')
  if (response.data.code !== 0) throw new Error(response.data.message)
  return response.data.data
}

export async function getLegalDocument(slug: string): Promise<LegalDocument> {
  const response = await apiClient.get<ApiEnvelope<LegalDocument>>(
    `/v1/platform/legal-documents/${encodeURIComponent(slug)}`,
  )
  if (response.data.code !== 0) throw new Error(response.data.message)
  return response.data.data
}
